module.exports = __webpack_public_path__ + "app/images/placeholder-event-item@2x.jpg";